/* 뒤로가기(bfcache)로 돌아왔을 때 장바구니 UI 가 열린 채로 남는 것을 닫는다.

   ⚠️⚠️ **실제 범인은 테마가 아니라 Corner 앱이다 (2026-09-15 실측 정정).**
      처음엔 Dawn `#cart-notification` 만 닫게 만들었는데 제보가 계속됐다.
      라이브에서 재보니 뜨는 것은 앱 익스텐션이 심는 `#corner-cowi-open-wrapper`
      (`cdn.shopify.com/extensions/.../corner-143/assets/cornerWidget.js`) 였다.
      ⚠️ 이 테마에는 `cart-drawer` 요소가 **아예 없다**(`querySelector('cart-drawer')` === null) —
         "드로워"를 테마에서 찾으면 아무 일도 안 일어난다.

   기전: `Buy Now`(`.nt-buynow`)는 `/cart/add` 폼의 버튼이라 담기 → 결제로 넘어간다.
   그 사이 Corner 가 카트를 연다. 결제에서 뒤로 오면 브라우저가 **그 DOM·JS 상태를 그대로
   복원**해 열린 채로 보인다. 서버 렌더는 닫힌 상태라 새로고침하면 사라진다.

   ⚠️ Corner 는 **공식 API 로 닫는다** — `corner.do('closeCart')`
      (실측: 내부 스토어 `isCowiOpened` 를 false 로 두고 `onCowiClose` 훅까지 실행한다).
      클래스를 직접 떼면 앱의 상태와 어긋나 다음 열기가 이상해진다.
   ⚠️ 열림 판정 = 래퍼에 **`inert` 가 없다**(실측: 닫힘 `aria-hidden="true" inert`,
      열림 둘 다 제거 + 카드가 `opacity-100 translate-x-0`).
   ⚠️ 뒤로가기 뒤 **늦게** 열릴 수 있어(앱 초기화·카트 동기화) 짧게 지켜본다.
      ⚠️ 사용자가 직접 누르면 즉시 감시를 멈춘다 — 안 그러면 사용자가 연 카트를 우리가 닫는다.

   ⚠️⚠️ **닫기는 항상 하되 "지켜보기"는 뒤로가기일 때만 한다.** 처음엔 무조건 2.5초를
      지켜봤는데, 실측에서 **첫 로드 직후 연 카트가 우리 손에 닫혔다**. 판정은
      `event.persisted` 또는 navigation type `back_forward` 이고, 둘 중 하나라도 맞으면 켠다
      (브라우저마다 bfcache 판정이 달라 한쪽만 보면 놓친다).
      ⚠️ 1회 닫기는 그대로 모든 `pageshow` 에서 한다 — 첫 로드면 이미 닫혀 있어 무해하다.
   ⚠️ `overflow-hidden` 은 **우리가 무언가를 닫았을 때만** 뗀다 — 무조건 떼면 메뉴 드로어가
      열린 채 복원된 경우 그 잠금까지 풀려 뒤가 스크롤된다.
   ⚠️ 컴포넌트의 `close()` 가 있으면 그걸 부른다(포커스 트랩 해제가 거기 있다). */
(function () {
  var WATCH_MS = 2500;
  var watchUntil = 0;
  var timer = null;

  function closeCornerCart() {
    var wrapper = document.getElementById('corner-cowi-open-wrapper');
    if (!wrapper || wrapper.hasAttribute('inert')) return false;

    var api = window.corner;
    if (api && typeof api.do === 'function') api.do('closeCart');
    else {
      var btn = document.getElementById('corner-cowi-close-btn');
      if (btn) btn.click();
      else return false;
    }
    return true;
  }

  function closeThemeCartUi() {
    var closed = false;

    var notification = document.getElementById('cart-notification');
    if (notification && notification.classList.contains('active')) {
      var component = document.querySelector('cart-notification');
      if (component && typeof component.close === 'function') component.close();
      else notification.classList.remove('active', 'animate');
      closed = true;
    }

    // 드로워를 쓰는 구성으로 바뀌어도 같은 문제가 난다 — 미리 함께 닫는다.
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) {
      if (typeof drawer.close === 'function') drawer.close();
      else drawer.classList.remove('active', 'animate');
      closed = true;
    }

    return closed;
  }

  function closeRestoredCartUi() {
    var closed = closeThemeCartUi();
    if (closeCornerCart()) closed = true;
    if (closed) document.body.classList.remove('overflow-hidden');
  }

  function stopWatch() {
    watchUntil = 0;
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function isBackForward(event) {
    // popstate 는 그 자체가 뒤로/앞으로 이동이다.
    if (event && event.type === 'popstate') return true;
    if (event && event.persisted) return true;
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      return !!nav && nav.type === 'back_forward';
    } catch (e) {
      return false;
    }
  }

  function startWatch(event) {
    closeRestoredCartUi();
    if (!isBackForward(event)) return;
    watchUntil = Date.now() + WATCH_MS;
    if (timer) return;
    timer = setInterval(function () {
      if (Date.now() > watchUntil) {
        stopWatch();
        return;
      }
      closeRestoredCartUi();
    }, 200);
  }

  window.addEventListener('pageshow', startWatch);
  window.addEventListener('popstate', startWatch);
  document.addEventListener('pointerdown', stopWatch, true);
  document.addEventListener('keydown', stopWatch, true);
})();
